import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {PathService} from "./path.service";
import {Observable} from "rxjs";
import {AnyMap, IdInfo, ListWrapper, OkInfo} from "../util/interfaces";
import {map} from "rxjs/operators";
import {OrderStatus} from "./order.service";

export interface SiteUser {
    id: number;
    email: string;
    created: string;
    updated?: string;
    disabled?: string;
    firstName: string;
    lastName: string;
    birthDate?: string;
    gender?: 'M'|'F';
    race?: string[];
    ethnicity?: string;
    orderCount: number;
    orderNumber: number;
    orderStatus: string;
    orderTotal: number;
    orderTime: string;
    street: string;
    street2: string|null;
    city: string;
    state: string;
    zip: string;
    phone: string;
    selected?: boolean;
}

export interface DetailedOrder {
    id: number;
    order_number: number;
    created: Date;
    updated: Date;
    status: OrderStatus;
    tax: number;
    shipping: number;
    discount: number;
    subtotal: number;
    total: number;
    items: OrderItem[];
    history: OrderHistoryEvent[];
}

export interface OrderItem {
    sku: string;
    name: string;
    unit_price: number;
    count: number;
    status: string;
    tracking_number: string;
    zpl_label: string;
}

export interface OrderHistoryEvent {
    status: OrderStatus;
    created: Date;
}

@Injectable({
    providedIn: 'root'
})
export class SiteUserService {

    private readonly root: string;

    constructor(private http: HttpClient,
                private pathService: PathService) {
        this.root = `${this.pathService.apiRoot}/patient-user`;
    }

    getAll(): Observable<SiteUser[]> {
        return this.http.get<ListWrapper<SiteUser>>(this.root).pipe(
            map((out) => {
                return out.list;
            })
        )
    }

    public add(email: string, firstName: string, lastName: string, birthDate?: string, gender?: 'M'|'F',
               race?: string, ethnicity?: string): Observable<IdInfo> {
        let body: AnyMap = {email: email, firstName: firstName, lastName: lastName};
        if (birthDate)
            body.birthDate = birthDate;
        if (gender)
            body.gender = gender;
        if (race)
            body.race = race;
        if (ethnicity)
            body.ethnicity = ethnicity;
        return this.http.post<IdInfo>(this.root, body);
    }

    public update(user: SiteUser): Observable<OkInfo> {
        return this.http.put<OkInfo>(`${this.root}/${user.id}`, user);
    }

    public disable(user: SiteUser): Observable<OkInfo> {
        return this.http.delete<OkInfo>(`${this.root}/${user.id}`);
    }

    public enable(user: SiteUser): Observable<OkInfo> {
        return this.http.put<OkInfo>(`${this.root}/${user.id}/enabled`, {})
    }

    public getOrders(user: SiteUser): Observable<DetailedOrder[]> {
        return this.http.get<ListWrapper<DetailedOrder>>(`${this.root}/${user.id}/orders`).pipe(
            map((out) => out.list)
        );
    }
}
